import { useTooltip } from 'contexts/Tooltip/Tooltip';
import { useState } from 'react';
import { v4 } from 'uuid';

export default function Info({ children }: InfoProps) {
    const [debounce, setDebounce] = useState<any>(null);
    const tooltip = useTooltip();

    function handleMouseOut() {
        if (debounce) {
            clearTimeout(debounce);
            setDebounce(null);
        }
    }

    function handleShow(e: any) {
        const buttonRect = e.currentTarget.getBoundingClientRect();
        const x = buttonRect.left + 6;
        const y = buttonRect.top + 6;

        const newDebounce = setTimeout(() => {
            setDebounce(null);
            tooltip.show(x, y, children);
        }, 100);

        setDebounce(newDebounce);
    }

    return (
        <button
            id={`${v4()}-nic`}
            className="info pdf-hide"
            type="button"
            onClick={handleShow}
            onMouseOut={handleMouseOut}
            onMouseOver={handleShow}
            aria-label={`${children[0]?.props?.title} - Info`}
        />
    );
}
